import type {SchedulerOrgTemplatesState} from 'src/types/scheduler/org-templates';
import type {SchedulerOrgTemplateActions} from 'src/action-creators/scheduler/org-templates';

import {
  SET_ORG_TEMPLATES,
  ADD_ORG_TEMPLATE,
  REMOVE_ORG_TEMPLATE,
  UPDATE_ORG_TEMPLATE,
  SET_ORG_TEMPLATES_FILTERS,
  SET_ORG_TEMPLATE_ASSIGNMENTS,
} from 'src/action-creators/scheduler/org-templates';


const initialOrgTemplatesState = {
  data: [],
  filters: {
    name: '',
  },
} as SchedulerOrgTemplatesState;

export default (
  state: SchedulerOrgTemplatesState = initialOrgTemplatesState,
  action: SchedulerOrgTemplateActions,
): SchedulerOrgTemplatesState => {
  switch (action.type) {
    case SET_ORG_TEMPLATES:
      return {
        ...state,
        data: action.payload,
      };
    case ADD_ORG_TEMPLATE:
      return {
        ...state,
        data: [action.payload, ...state.data],
      };
    case REMOVE_ORG_TEMPLATE:
      return {
        ...state,
        data: state.data.filter((template) => template.id !== action.payload),
      };
    case UPDATE_ORG_TEMPLATE:
      return {
        ...state,
        data: state.data.map((template) =>
          template.id === action.payload.templateId
            ? action.payload.payload
            : template,
        ),
      };
    case SET_ORG_TEMPLATES_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case SET_ORG_TEMPLATE_ASSIGNMENTS:
      const {templateId, assignments} = action.payload;
      return {
        ...state,
        data: state.data.map((template) =>
          template.id === templateId
            ? {
                ...template,
                assignments: template.assignments
                  ? {...template.assignments, ...assignments}
                  : assignments,
              }
            : template,
        ),
      };
    default:
      return state;
  }
};
